const ASANA_API_URL = "https://app.asana.com/api/1.0";

export { ASANA_API_URL };
